import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";

import App from "~/App.tsx";
import AuthProvider from "~/auth/AuthProvider";
import dockLayoutHideFlushRegistry from "~/components/dock/dockLayoutHideFlushRegistry";
import installStaleBuildRecovery from "~/helpers/sw/staleBuildRecovery";
import { installBackGuardBeforeRouter } from "~/hooks/useUnsavedChangesGuard";
import emailedPasswordToken from "~/pages/register/helpers/emailedPasswordToken";
import { persistor, store } from "~/store";
import installPersistorCartFlush from "~/store/flushPersistorOnCartChange";
import installPersistorHideFlush from "~/store/flushPersistorOnHide";
import installWalkthroughE2E from "~/walkthroughs/walkthroughE2E";
import "~/i18n/i18n";
import "~/main.css";
import "~/material-symbols-subset.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";

if (import.meta.env["VITE_E2E_HOOKS"] === "true") {
	installWalkthroughE2E(store);
}

installStaleBuildRecovery();
installPersistorCartFlush(store, persistor);
installPersistorHideFlush(persistor, dockLayoutHideFlushRegistry.flushAll);
installBackGuardBeforeRouter();
emailedPasswordToken.install();

ReactDOM.createRoot(document.getElementById("root")!).render(
	//<React.StrictMode>
	<AuthProvider>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</PersistGate>
		</Provider>
	</AuthProvider>
	//</React.StrictMode>
);
